import type { ReactNode } from "react";
import { IconChevronRight } from "./Icons";

export type SidebarSectionFlyoutProps = {
  id: string;
  navId: string;
  label: string;
  icon: ReactNode;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export function SidebarSectionFlyout({
  id,
  navId,
  label,
  icon,
  open,
  onToggle,
  children,
}: SidebarSectionFlyoutProps) {
  const toggleClass =
    "sidebar__section-toggle" + (open ? " sidebar__section-toggle--active" : "");

  return (
    <div className="sidebar__section-wrap">
      <button
        type="button"
        className={toggleClass}
        id={id}
        aria-expanded={open}
        aria-controls={navId}
        onClick={onToggle}
      >
        <div className="sidebar__section-toggle-left">
          {icon}
          <span className="sidebar__section-toggle__text">{label}</span>
        </div>
        <IconChevronRight
          className={
            "sidebar__section-toggle__chevron" + (open ? " sidebar__section-toggle__chevron--open" : "")
          }
          aria-hidden
        />
      </button>

      <nav
        id={navId}
        className={"sidebar__sub-nav" + (open ? "" : " sidebar__sub-nav--collapsed")}
        aria-labelledby={id}
        aria-hidden={!open}
      >
        {children}
      </nav>
    </div>
  );
}
